/**
 * @description 批改-變更項目-輸入欄位類型
 */
export enum EndorseColType {
    /** 航班資訊 日期 */
    FLIGHT = 'FLIGHT',
    /** 地址 、 補發強制險保險證 */
    ADDRESS = 'ADDRESS',
    /** 標的物門牌整編 */
    FIRE_ADDRESS = 'FIRE_ADDRESS',
    /** 聯絡電話 */
    MOBILE = 'MOBILE',
    /** 電子郵件信箱 */
    EMAIL = 'EMAIL',
    /** 婚姻狀況 */
    RADIO = 'RADIO',
    /** 發照年月(下拉)*/
    SELECT = 'SELECT',
    /** 抵押權人 */
    MORTGAGE = 'MORTGAGE',
    /** 一般輸入欄位 、 名字、車身號碼、重領牌而變更車號 */
    STRING = 'STRING'
}
